import { render, staticRenderFns } from "./AccessModal.vue?vue&type=template&id=356a5529&scoped=true"
import script from "./AccessModal.vue?vue&type=script&lang=js"
export * from "./AccessModal.vue?vue&type=script&lang=js"
import style0 from "./AccessModal.vue?vue&type=style&index=0&id=356a5529&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356a5529",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/_work/studio-admin/studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('356a5529')) {
      api.createRecord('356a5529', component.options)
    } else {
      api.reload('356a5529', component.options)
    }
    module.hot.accept("./AccessModal.vue?vue&type=template&id=356a5529&scoped=true", function () {
      api.rerender('356a5529', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AccessModal.vue"
export default component.exports